(function () {
  'use strict';
  /* May be included by the collection AND the homepage product slider
     (for Quick Add). Run once, whatever loaded first. */
  if (window.__baeCollectionJS) return;
  window.__baeCollectionJS = true;

  const root = document.querySelector('[data-bae-collection]');

  /* ---------- Quick Add (global: collection grid + homepage slider) ---------- */
  let modal = null;
  function ensureModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'bae-qa';
    modal.innerHTML =
      '<div class="bae-qa__scrim" data-close></div>' +
      '<div class="bae-qa__panel" role="dialog" aria-modal="true">' +
      '<button class="bae-qa__close" type="button" aria-label="Sluiten" data-close>&times;</button>' +
      '<div data-body></div></div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', (e) => { if (e.target.hasAttribute('data-close')) closeModal(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeModal(); });
    return modal;
  }
  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-bae-quickadd]');
    if (!btn) return;
    e.preventDefault();
    const m = ensureModal();
    const body = m.querySelector('[data-body]');
    body.innerHTML = '<p class="bae-qa__price">Laden…</p>';
    m.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    fetch('/products/' + btn.dataset.baeQuickadd + '.js')
      .then((r) => r.json()).then((p) => renderQuickAdd(body, p))
      .catch(() => { body.innerHTML = '<p class="bae-qa__msg">Kon dit product niet laden.</p>'; });
  });

  function renderQuickAdd(body, p) {
    const money = (c) => (c / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
    const names = p.options.map((o) => (o.name || o));
    const sizeIdx = names.findIndex((n) => /size|maat/i.test(n));
    const colourIdx = names.findIndex((n) => /colou?r|kleur/i.test(n));
    const first = p.variants[0];
    const colour = colourIdx > -1 && first ? first.options[colourIdx] : '';
    const variants = colour ? p.variants.filter((v) => v.options[colourIdx] === colour) : p.variants;

    body.innerHTML =
      '<div class="bae-qa__row">' +
      (p.featured_image ? '<img class="bae-qa__img" src="' + p.featured_image + '&width=300" alt="">' : '') +
      '<div><h3 class="bae-qa__name">' + p.title + '</h3>' +
      '<p class="bae-qa__price">' + money(p.price) + '</p>' +
      (colour ? '<p class="bae-qa__colour">' + colour + '</p>' : '') +
      '</div></div>' +
      '<span class="bae-kicker bae-qa__label">' + (sizeIdx > -1 ? 'Maat' : 'Kies') + '</span>' +
      '<div class="bae-qa__sizes">' +
      variants.map((v) => '<button class="bae-qa__size" type="button" data-vid="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' +
        (sizeIdx > -1 ? v.options[sizeIdx] : v.title) + '</button>').join('') +
      '</div>' +
      '<button class="bae-btn bae-btn--primary bae-btn--block bae-qa__cta" type="button" disabled data-add>Kies een maat</button>' +
      '<p class="bae-qa__msg" data-msg></p>' +
      '<p style="margin-top:14px"><a class="bae-link" href="' + p.url + '">Bekijk product</a></p>';

    let selected = null;
    const cta = body.querySelector('[data-add]');
    const msg = body.querySelector('[data-msg]');

    /* Single-variant products (one-size caps, socks) need no size step:
       the only variant is pre-selected and the CTA is ready immediately.
       Without a real size option (Shopify's default "Title" variant) the
       size row is not shown at all. */
    if (variants.length === 1) {
      const only = body.querySelector('.bae-qa__size');
      if (only) only.classList.add('is-active');
      selected = String(variants[0].id);
      cta.disabled = false;
      cta.textContent = 'In winkelmand';
      if (sizeIdx === -1) {
        body.querySelector('.bae-qa__label').hidden = true;
        body.querySelector('.bae-qa__sizes').hidden = true;
      }
    }

    body.querySelectorAll('.bae-qa__size').forEach((b) => {
      b.addEventListener('click', () => {
        body.querySelectorAll('.bae-qa__size').forEach((x) => x.classList.remove('is-active'));
        b.classList.add('is-active');
        selected = b.dataset.vid;
        cta.disabled = false;
        cta.textContent = 'In winkelmand';
      });
    });

    cta.addEventListener('click', () => {
      if (!selected) return;
      cta.disabled = true;
      cta.textContent = 'Toevoegen…';
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(selected), quantity: 1 }] })
      })
        .then((r) => r.json()).then(() => fetch('/cart.js')).then((r) => r.json())
        .then((cart) => {
          document.dispatchEvent(new CustomEvent('bae:cart:updated', { detail: cart }));
          cta.textContent = 'Toegevoegd';
          setTimeout(closeModal, 550);
        })
        .catch(() => {
          msg.textContent = 'Er ging iets mis. Probeer opnieuw.';
          cta.disabled = false;
          cta.textContent = 'In winkelmand';
        });
    });
  }

  /* ---------- Card media (global: works on collection, PDP recs, search) ---------- */
  const cardTrack = (card) => card.querySelector('[data-bae-card-track]');

  /* signature slide bar on each card */
  function syncBar(card) {
    const track = cardTrack(card);
    const thumb = card.querySelector('[data-bae-card-thumb]');
    if (!track || !thumb) return;
    const count = track.children.length || 1;
    const w = 100 / count;
    const i = Math.round(track.scrollLeft / track.clientWidth);
    thumb.style.width = w + '%';
    thumb.style.left = (i * w) + '%';
  }
  function syncAllBars() {
    document.querySelectorAll('[data-bae-card]').forEach(syncBar);
  }

  document.addEventListener('scroll', (e) => {
    const track = e.target.closest ? e.target.closest('[data-bae-card-track]') : null;
    if (track) syncBar(track.closest('[data-bae-card]'));
  }, true);
  window.addEventListener('resize', syncAllBars);

  document.addEventListener('click', (e) => {
    const next = e.target.closest('[data-bae-card-next]');
    const prev = e.target.closest('[data-bae-card-prev]');
    if (next || prev) {
      e.preventDefault();
      const track = cardTrack((next || prev).closest('[data-bae-card]'));
      if (track) track.scrollBy({ left: (next ? 1 : -1) * track.clientWidth, behavior: 'smooth' });
      return;
    }

    const sw = e.target.closest('[data-bae-swatch]');
    if (sw) {
      e.preventDefault();
      const card = sw.closest('[data-bae-card]');
      card.querySelectorAll('[data-bae-swatch]').forEach((s) => s.classList.remove('is-active'));
      sw.classList.add('is-active');

      const img = sw.dataset.img;
      const first = card.querySelector('.bae-card__slide img');
      if (img && first) { first.src = img; first.removeAttribute('srcset'); }

      const label = card.querySelector('[data-bae-card-colour]');
      if (label && sw.dataset.colour) label.textContent = sw.dataset.colour;

      const url = sw.dataset.variantUrl;
      if (url) card.querySelectorAll('a.bae-card__link, a.bae-card__name').forEach((a) => (a.href = url));
    }
  });

  if (!root) { syncAllBars(); return; }

  /* ---------- fit + view ---------- */
  let currentFit = 'all';
  let currentView = 'flat';
  /* True while the remaining pagination pages are pulled in so a fit selection
     can be judged against the whole collection instead of the first page. */
  let completing = false;

  /* Looked up live: a sort/filter re-render replaces the markup inside
     [data-bae-collection], so cached element references go stale. */
  const fitButtons = () => root.querySelectorAll('[data-bae-fit]');
  const viewButtons = () => root.querySelectorAll('[data-bae-view]');

  /* Editorial moments. The tiles are rendered once by Liquid at the end of the
     grid and are MOVED here (never cloned), so filtering, sorting and infinite
     loading can never produce a duplicate or a tile stranded between hidden
     product nodes. Tile n sits directly behind the (n * 4)th visible product. */
  function placeCampaigns(shown) {
    const grid = root.querySelector('[data-bae-grid]');
    if (!grid) return;
    [1, 2].forEach((n) => {
      const tile = root.querySelector('[data-bae-campaign="' + n + '"]');
      if (!tile) return;
      const at = n * 4;
      if (shown.length <= at) { tile.hidden = true; return; }
      const ref = shown[at];
      if (tile.parentNode !== grid || tile.nextElementSibling !== ref) grid.insertBefore(tile, ref);
      tile.hidden = false;
    });
  }

  function apply() {
    let visible = 0;
    const shown = [];
    root.querySelectorAll('[data-bae-card]').forEach((card) => {
      const cardFit = normFit((card.dataset.fit || '').trim());
      const show = currentFit === 'all' || cardFit === currentFit;
      card.style.display = show ? '' : 'none';
      if (!show) return;
      visible += 1;
      shown.push(card);

      /* Deterministic media per mode; reset the card slider to the first
         slide so the switch is always visible, whatever was swiped. */
      const src = currentView === 'model' ? card.dataset.modelSrc : card.dataset.flatSrc;
      const img = card.querySelector('.bae-card__slide img');
      if (src && img && img.getAttribute('src') !== src) { img.src = src; img.removeAttribute('srcset'); }
      const tr = card.querySelector('[data-bae-card-track]');
      if (tr && tr.scrollLeft > 0) tr.scrollTo({ left: 0 });
      card.classList.toggle('is-model', currentView === 'model');
    });

    placeCampaigns(shown);

    const morePages = !!root.querySelector('[data-bae-more]');
    /* An empty result is only real once the whole collection is loaded. */
    const provisional = completing && visible === 0;
    /* With ALLE FITS active and pages still unloaded the rendered cards are a
       subset, so the server-rendered collection total stays the honest number. */
    const partial = currentFit === 'all' && morePages;
    const nofit = root.querySelector('[data-bae-nofit]');
    const countEl = root.querySelector('[data-bae-count]');

    if (nofit) {
      nofit.hidden = visible !== 0 || provisional;
      if (visible === 0 && !provisional) nofit.textContent = 'Geen stuks in deze pasvorm binnen deze selectie.';
    }
    if (countEl && !provisional && !partial) countEl.textContent = visible + (visible === 1 ? ' item' : ' items');
    syncAllBars();

    try {
      sessionStorage.setItem('bae:fit', currentFit);
      sessionStorage.setItem('bae:view', currentView);
    } catch (err) {}
  }

  function setView(mode) {
    currentView = mode;
    viewButtons().forEach((x) => x.classList.toggle('is-active', x.dataset.baeView === mode));
    apply();
  }

  /* Delegated on the section root so both toggles survive a re-render. */
  root.addEventListener('click', (e) => {
    const fb = e.target.closest('[data-bae-fit]');
    if (fb) {
      fitButtons().forEach((x) => x.classList.remove('is-active'));
      fb.classList.add('is-active');
      currentFit = fb.dataset.baeFit;
      if (window.BaeToggle) window.BaeToggle.sync();
      apply();
      ensureFullSet();
      return;
    }
    const vb = e.target.closest('[data-bae-view]');
    if (vb) {
      setView(vb.dataset.baeView);
      if (window.BaeToggle) window.BaeToggle.sync();
    }
  });

  /* One normalization layer for fit values: anything containing 'box' → 'box',
     anything containing 'oversized' → 'oversized'. Cards emit the same values. */
  const normFit = (v) => {
    v = (v || '').toLowerCase();
    if (v === 'all' || v === '') return v || 'all';
    if (v.indexOf('box') > -1) return 'box';
    if (v.indexOf('oversized') > -1) return 'oversized';
    return v;
  };

  /* Re-paint the active state of freshly rendered controls from the state the
     visitor already chose. */
  function restoreControlState() {
    fitButtons().forEach((x) => x.classList.toggle('is-active', x.dataset.baeFit === currentFit));
    viewButtons().forEach((x) => x.classList.toggle('is-active', x.dataset.baeView === currentView));
    if (window.BaeToggle) window.BaeToggle.sync();
  }

  /* Show a control only when it offers a real choice in THIS collection:
     - fit selector needs BOTH fit families among the rendered products;
     - media selector needs at least one product with distinct model media.
     Re-evaluated after infinite scroll adds products. */
  function updateControls() {
    const cards = Array.from(root.querySelectorAll('[data-bae-card]'));
    const fits = new Set();
    cards.forEach((c) => {
      const f = normFit((c.dataset.fit || '').trim());
      if (f && f !== 'all') fits.add(f);
    });
    const fitBtn = root.querySelector('[data-bae-fit]');
    const fitGroup = fitBtn ? fitBtn.closest('.bae-toggle') : null;
    if (fitGroup) {
      /* Keep the fit control visible while more products can still load: on a
         paginated collection the second fit family may only appear on a later
         page, so hiding purely on the current page wrongly removed the toggle.
         Only hide once the whole set is known (no more pages) AND it has <2 fits. */
      const moreToLoad = !!root.querySelector('[data-bae-more]');
      fitGroup.hidden = fits.size < 2 && !moreToLoad;
      if (fitGroup.hidden && currentFit !== 'all') {
        currentFit = 'all';
        fitButtons().forEach((x) => x.classList.toggle('is-active', x.dataset.baeFit === 'all'));
      }
    }
    const hasModel = cards.some((c) => c.dataset.hasModel === '1');
    const viewBtn = root.querySelector('[data-bae-view]');
    const viewGroup = viewBtn ? viewBtn.closest('.bae-toggle') : null;
    if (viewGroup) {
      viewGroup.hidden = !hasModel;
      if (viewGroup.hidden && currentView !== 'flat') {
        currentView = 'flat';
        viewButtons().forEach((x) => x.classList.toggle('is-active', x.dataset.baeView === 'flat'));
      }
    }
    if (window.BaeToggle) window.BaeToggle.sync();
  }

  try {
    const savedFit = normFit(sessionStorage.getItem('bae:fit'));
    if (savedFit) {
      const b = root.querySelector('[data-bae-fit="' + savedFit + '"]');
      if (b) { fitButtons().forEach((x) => x.classList.remove('is-active')); b.classList.add('is-active'); currentFit = savedFit; }
    }
    const savedView = sessionStorage.getItem('bae:view');
    if (savedView) currentView = savedView;
  } catch (err) {}
  updateControls();
  setView(currentView);

  /* ---------- filters + sort ---------- */
  root.addEventListener('click', (e) => {
    if (e.target.closest('[data-bae-filters-open]')) {
      const f = root.querySelector('[data-bae-filters]');
      if (f) f.hidden = !f.hidden;
    } else if (e.target.closest('[data-bae-filters-close]')) {
      const f = root.querySelector('[data-bae-filters]');
      if (f) f.hidden = true;
    }
  });

  function navigate(url) {
    root.style.opacity = '.45';
    fetch(url).then((r) => r.text()).then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-bae-collection]');
      if (fresh) root.innerHTML = fresh.innerHTML;
      window.history.replaceState({}, '', url);
      root.style.opacity = '';
      bindMore();
      updateControls();
      restoreControlState();
      apply();
      ensureFullSet();
    }).catch(() => { window.location.href = url; });
  }

  root.addEventListener('change', (e) => {
    const form = e.target.closest('[data-bae-filters]');
    if (form) {
      const params = new URLSearchParams(new FormData(form));
      const sort = root.querySelector('[data-bae-sort]');
      if (sort && sort.value) params.set('sort_by', sort.value);
      navigate(window.location.pathname + '?' + params.toString());
      return;
    }
    const sort = e.target.closest('[data-bae-sort]');
    if (!sort) return;
    const params = new URLSearchParams(window.location.search);
    params.set('sort_by', sort.value);
    navigate(window.location.pathname + '?' + params.toString());
  });

  /* ---------- pagination ---------- */
  let loading = false;
  let observer = null;

  /* Single append path, shared by the scroll observer and by ensureFullSet(),
     so a page is never appended twice or in two different ways.
     Resolves 'error' on a failed fetch, otherwise undefined. */
  function loadNext() {
    const sentinel = root.querySelector('[data-bae-more]');
    if (!sentinel || loading) return Promise.resolve();
    loading = true;
    return fetch(sentinel.dataset.nextUrl).then((r) => r.text()).then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const cards = doc.querySelectorAll('[data-bae-grid] > [data-bae-card]');
      const g = root.querySelector('[data-bae-grid]');
      cards.forEach((c) => g.appendChild(document.importNode(c, true)));
      const nextSentinel = doc.querySelector('[data-bae-more]');
      if (nextSentinel) sentinel.dataset.nextUrl = nextSentinel.dataset.nextUrl;
      else { sentinel.remove(); if (observer) observer.disconnect(); }
      loading = false;
      updateControls();
      apply();
    }).catch(() => { loading = false; return 'error'; });
  }

  function bindMore() {
    const sentinel = root.querySelector('[data-bae-more]');
    if (observer) observer.disconnect();
    if (!sentinel) return;
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => { if (entry.isIntersecting) loadNext(); });
    }, { rootMargin: '600px 0px' });
    observer.observe(sentinel);
  }

  /* A fit selection must be judged against the WHOLE collection. The grid is
     paginated, so a fit family can live entirely on later pages — that is what
     produced a false "0 items" state for OVERSIZED. Pull the remaining pages
     in before an empty state is allowed to show. */
  function ensureFullSet() {
    if (completing || currentFit === 'all') return;
    if (!root.querySelector('[data-bae-more]')) return;
    completing = true;
    let guard = 40;
    const step = () => {
      if (!root.querySelector('[data-bae-more]') || guard-- <= 0) { completing = false; apply(); return; }
      if (loading) { setTimeout(step, 90); return; }
      loadNext().then((res) => {
        if (res === 'error') { completing = false; apply(); return; }
        setTimeout(step, 0);
      });
    };
    apply();
    step();
  }

  bindMore();
  ensureFullSet();
})();
